import type { ColorTag } from "@color-finder/color-finder-api/models";
import {
  Alert,
  AlertTitle,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import type { FC } from "react";

export const restrictionsText: string =
  "There are restrictions for this color / grade combination";

export const RestrictionsBanner: FC<{ value: Array<ColorTag> }> = ({
  value,
}) => {
  if (!value.length) return null;
  return (
    <Paper variant="outlined">
      <Alert severity="warning">
        <AlertTitle>{restrictionsText}</AlertTitle>
        <List sx={{ padding: 0 }} dense>
          {value.map((v) => (
            <ListItem key={v.value} disableGutters>
              <ListItemText
                primary={v.name}
                secondary={v.description}
              ></ListItemText>
            </ListItem>
          ))}
        </List>
      </Alert>
    </Paper>
  );
};
